import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { GALLERY_CONVERTER_TOKEN, GalleryConverter } from './gallery.component.converter'
import { GALLERY_ITEM_CONVERTER_TOKEN, GalleryItemConverter } from './gallery-item/gallery-item.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        galleryFeature: {
          module: () => import('./gallery.module').then((m) => m.GalleryModule),
          cmsComponents: ['gallery']
        },
      }
    }),
    {
      provide: GALLERY_CONVERTER_TOKEN,
      useExisting: GalleryConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        gallery: GALLERY_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: GALLERY_ITEM_CONVERTER_TOKEN,
      useExisting: GalleryItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        gallery_item: GALLERY_ITEM_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class GalleryFeatureModule {}
